// extracted by mini-css-extract-plugin
export default {"PathShowFrame":"locationShow_PathShowFrame__MST9m"};